(ns frontend.view.entity-viewers.header
  (:require
   [common.localization :as loc]
   [common.schema.entities.pipeline :as pipeline]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as state-permissions]
   [frontend.utils :as fu]
   [frontend.view.entity-viewers.header-fields :as header-fields]
   [frontend.view.field-templates :as templates]
   [frontend.view.modals.curtains.nev-editor-curtain.view :as nev-editor]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.layout-editor.view :as layout-editor-modal]
   [potpuri.core :refer [fn->]]
   [reagent.core :as r]
   [ui.components.button.view :as button]))

;; NEV 2.5 updated header:
(defn header-board
  [{:keys [top entity-id field-defs row-editor-args schema editor-remove-fields actions
           edit-layout? set-edit-layout! save-layout!]}]
  (let [entity-atom (r/cursor session/entities [entity-id])
        open-layout-editor! (fn [layout-schema header-schema field-defs top]
                              (modals/open-modal!
                               layout-editor-modal/modal-key
                               {:entity-id     entity-id
                                :field-defs    field-defs
                                :layout-schema layout-schema
                                :header-schema header-schema
                                :top           top
                                :save-layout!  save-layout!}))
        local-state (r/atom {})]
    (fn [{:keys [top preview-top field-defs row-editor-args schema editor-remove-fields actions
                 edit-layout? set-edit-layout! save-layout!]}]
      (let [entity @entity-atom
            entity-type (:entity/type entity)

            layout-schema (->> schema
                               (remove
                                (fn-> second :field/data-type (= :data.type/currency-symbol)))
                               (remove (fn-> second :field/data-type (= :data.type/text-edn))))
            header-schema (->> schema
                               (remove
                                (fn-> second :field/data-type (= :data.type/currency-symbol)))
                               (remove (fn-> second :field/data-type (= :data.type/text-edn))))

            selected-fields-set (->> field-defs
                                     (map :fields)
                                     (mapcat vals)
                                     (keep :field)
                                     set)
            selected-fields-schema (->> schema
                                        (filter (fn-> first selected-fields-set)))
            pipeline-id (pipeline/entity-pipeline entity)

            ;; not editable via editor-curtain:
            non-editable-fields (concat [:oppo/pipeline
                                         :fundraising-opportunity/pipeline
                                         :sales-opportunity/pipeline
                                         :exit-opportunity/pipeline
                                         :oppo/stage
                                         :fundraising-opportunity/opportunity-stage
                                         :sales-opportunity/stage
                                         :exit-opportunity/stage
                                         :oppo/status
                                         :fundraising-opportunity/status
                                         :sales-opportunity/status
                                         :exit-opportunity/status])
            remove-fields (concat non-editable-fields
                                  editor-remove-fields)
            remove-fields-set (set remove-fields)
            editor-schema
            (->> selected-fields-schema
                 (keep
                  (fn [[k {:keys [attribute] :as fs}]]
                    (let [attribute-entity (fu/base-entity entity k)
                          access? (state-permissions/field-write-access?
                                   attribute
                                   (:entity/type attribute-entity)
                                   pipeline-id)
                          valid? (templates/valid-attribute? attribute attribute-entity)]
                      (when (and attribute-entity
                                 access?
                                 valid?)
                        [k
                         (templates/entity-field-schema
                          {:attribute    k
                           :field-schema fs
                           :entity       attribute-entity
                           :tenant       @frontend.state.current-session/tenant
                           :account      @frontend.state.current-session/account
                           :role         @frontend.state.current-session/role
                           :pipeline-id  pipeline-id})]))))
                 (remove (fn-> first remove-fields-set))
                 (remove (fn-> second :read-only?))
                 (remove (fn-> second :editor/type (= :editor.type/allocation-split)))
                 (remove (fn-> second :field/data-type (= :data.type/currency-symbol)))
                 (remove (fn-> second :field/composite-attributes))
                 (remove (fn-> second :field/calculated-field))
                 (remove (fn-> second :editor/type (= :editor.type/link))))]
        [:div
         {:class "p-4 mb-2 bg-base-light border border-solid border-base-light-border-paler rounded transition"}
         [:div
          {:class "flex gap-3"}
          [:div
           {:class "flex-auto"}
           top]
          (when-not edit-layout?
            [:div
             {:class "flex items-center gap-3"}
             (when-not (session/is-read-only-user?)
                [button/sm-secondary-hollow
                {:on-click   (fn [_]
                               (modals/open-modal!
                                nev-editor/modal-key
                                {:entity-id  entity-id
                                 :field-defs field-defs
                                 :schema     editor-schema}))}
                (loc/tr :edit)])
             [fu/tooltip-overlay
              {:id "edit-layout"}
              (loc/tr :edit-layout)
              [button/square-secondary-open
               {:on-click (r/partial open-layout-editor!
                                     layout-schema
                                     header-schema
                                     field-defs
                                     (or preview-top top))}
               [:i.fal.fa-cog.text-xl]]]])]
         [:div
          [header-fields/view
           {:entity     @entity-atom
            :field-defs field-defs
            :schema     header-schema}]

          (when edit-layout?
            [:div.flex.gap-3.mt-5.edit-layout-buttons
             [button/primary-solid
              {:on-click   (fn [_]
                             (save-layout! (:field-defs @local-state))
                             (reset! local-state {})
                             (set-edit-layout! false))}
              (loc/tr :save-layout)]
             [button/secondary-hollow
              {:on-click   (partial set-edit-layout! false)}
              (loc/tr :cancel)]

             [fu/tooltip-overlay
              {:id "save-as-new-view"}
              (loc/tr :available-shortly-premium)
              [:span.clickable
               [button/primary-open
                {:variant    "link"}
                [:i.fal.fa-lock]
                (loc/tr :save-as-new-view)]]]

             [fu/tooltip-overlay
              {:id "share-view-with-others"}
              (loc/tr :available-shortly-premium)
              [:span.clickable
               [button/secondary-hollow
                {:variant    "link"}
                [:i.fal.fa-lock]
                (loc/tr :share-view-with-others)]]]])]]))))
